<template>
    <v-container fluid>
        <v-data-table class="elevation-1" :headers="table.headers" :items="table.items" :items-per-page="15">
            <!-- Program -->
            <template v-slot:item.program="{item}">
                {{ item.kodeProgram }} - {{ item.namaProgram }}
            </template>
            <!-- Kegiatan -->
            <template v-slot:item.kegiatan="{item}">
                {{ item.kode }} - {{ item.nama }}
            </template>
            <!-- Nilai Pagu -->
            <template v-slot:item.pagu="{item}">
                {{ getNumberSep(item.pagu) }}
            </template>
            <!-- Pagu Terpakai -->
            <template v-slot:item.paguTerpakai="{item}">
                {{ getNumberSep(item.paguTerpakai) }}
            </template>

            <!-- Sisa Pagu -->
            <template v-slot:item.paguSisa="{item}">
                {{ getNumberSep(item.pagu - item.paguTerpakai) }}
            </template>
        </v-data-table>
    </v-container>
</template>


<script>

const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { itemsJenisPengadaan } from './../lib/viewTenderLib'

export default {
    data() {
        return {
            table: {
                headers: [
                    { text: "Program", value: "program", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Kegiatan", value: "kegiatan", class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Jenis Pengadaan", value: "jenisPengadaan", align: 'end', class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    { text: "Tahun", value: "tahunAnggaran", align: 'end', class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    // { text: "Nilai Pagu", value: "pagu", align: 'end', class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    // { text: "Pagu Terpakai", value: "paguTerpakai", align: 'end', class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                    // { text: "Sisa Pagu", value: "paguSisa", align: 'end', class: "light-blue lighten-2 subtitle-1 font-weight-bold" },
                ],
                items: []
            },
            listJenisPengadaan: [],
        }
    }, // data

    mounted() {
        this.listJenisPengadaan = itemsJenisPengadaan

        console.log('this.listJenisPengadaan', this.listJenisPengadaan);
        const currentYear = (new Date()).getFullYear();

        axios.get(`${apiUrl}/api/rup/kegiatan-program/${currentYear}`)
        .then( (response) => {
            let data = response.data;
            

            data.forEach(element => {
                
                this.table.items.push({
                    kode: element.kode,
                    nama: element.nama,
                    pagu: element.pagu,
                    paguTerpakai: element.paguTerpakai,
                    jenisPengadaan: this.listJenisPengadaan.find(el => el.value === element.jenisPengadaan).text,
                    tahunAnggaran: element.tahunAnggaran,
                    kodeProgram: element.kodeProgram,
                    namaProgram: element.namaProgram,
                });
            });
        })
        .catch( (error) => {
            console.error(error);
        });
        
    }, // mounted

    methods: {
        getNumberSep: function(data) {
            return parseInt(data, 10).toLocaleString('de-DE')
        },

    }, // methods
}

</script>